__webpack_require__.p = "/reports-charts-repaint/referrals-hub/";